import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static values = {
    checkpointOneCompleted: Boolean,
    checkpointTwoCompleted: Boolean,
    videoWatched: Boolean,
    attendanceCompleted: Boolean
  }

  static targets = ["checkpointOneItem", "checkpointTwoItem", "watchVideoItem"]

  onCheckpointChecked(evt){
    if(evt.detail.checkpointIndex === 0) {
      this.checkpointOneItemTarget.classList.add("-completed")
    } else if(evt.detail.checkpointIndex === 1) {
      this.checkpointTwoItemTarget.classList.add("-completed")
    }
  }

  onVideoWatched(){
    this.watchVideoItemTarget.classList.add("-completed")
  }
}
